module.exports = __webpack_public_path__ + "static/media/about-2-bg.f1cdceef.jpg";